import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-error',
    templateUrl: './custom-error.component.html',
    styleUrls: ['./custom-error.component.css'],
    standalone: false
})
export class CustomErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
